import React, { Component } from "react"
import axios from "axios"
import { Button, Modal, OverlayTrigger, ProgressBar, Spinner, Tooltip } from "react-bootstrap"
import AxiosConfig from "../../../../../../../utilities/AxiosConfig"
import reggie from "../../../../../../../utilities/Reggie"
import snackBar from "../../../../../../../utilities/snackBar/SnackBar"
import ReviewChecklistTypes from "../../ReviewTypes/ReviewChecklistTypes"
import ReviewChecklistConfig from "./ReviewChecklistConfig/ReviewChecklistConfig"
import "./ReviewChecklist.css"

interface Props {
    EmployeeReviewId: number
    reviewerId: string | number
    employeeName: string
    readOnly: boolean
}

type State = {
    checklist: Array<ReviewChecklistTypes> | []
    confirm: boolean
    loading: boolean
    config: boolean
}

class ReviewChecklist extends Component<Props, State>{

    checklistCopy: Array<ReviewChecklistTypes> = []
    index = 0
    state = {
        checklist: [],
        confirm: false,
        loading: true,
        config: false
    }

    componentDidMount() {
        this.getReviewChecklist()
    }

    getReviewChecklist = () => {
        this.setState({ loading: true })
        let EmployeeReviewId = this.props.EmployeeReviewId
        if (EmployeeReviewId) {
            axios.get(process.env.REACT_APP_API_URL + `/api/employeereview/getReviewChecklist/${EmployeeReviewId}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    // //console.log("getReviewChecklist:", res.data)
                    this.setState({ checklist: res.data, loading: false })
                    this.checklistCopy = JSON.parse(JSON.stringify(res.data))
                })
                .catch((err) => {
                    this.setState({ loading: false })
                    snackBar({ text: "Failed to fetch Review checklist", type: "error", timeout: 4000 })
                })
        } else {
            setTimeout(() => {
                this.getReviewChecklist()//for some reason EmployeeReviewId is null on mount 
            }, 500)
        }
    }

    updateChecklist = (item: ReviewChecklistTypes) => {
        this.setState({ loading: true })
        axios.post(process.env.REACT_APP_API_URL + "/api/employeeReview/addOrUpdateReviewChecklist", item, AxiosConfig.configValue("min"))
            .then(() => {
                this.getReviewChecklist()
                snackBar({ text: "Updated Review checklist", type: "success", timeout: 4000 })
            })
            .catch(() => {
                this.setState({ loading: false })
                snackBar({ text: "Failed to update Review checklist", type: "error", timeout: 4000 })
            })
    }

    progress = () => {
        let sum = 0
        let checklist = this.state.checklist
        for (let i = 0; i < checklist.length; i++) {
            //@ts-ignore
            if (checklist[i].Checked) {
                sum++
            }
        }
        return { sum: `${sum}/${checklist.length}`, percent: (sum / checklist.length) * 100 }
    }

    calculateVariant = (progress: number) => {
        if (progress < 100) {
            return "warning"
        }
        return "primary"
    }

    modalHeaderText = () => {
        let item = this.state.checklist[this.index]
        //@ts-ignore
        if (item.Checked) {
            return (
                <div className="ConfirmReviewCheckedModalHeader">
                    <p>Mark this item as complete?</p>
                </div>
            )
        }
        return (
            <div className="ConfirmReviewCheckedModalHeader">
                <p>Mark this item as incomplete?</p>
            </div>
        )
    }

    modalBodyText = () => {
        let item = this.state.checklist[this.index]
        //@ts-ignore
        let text = item.ChecklistText
        //@ts-ignore
        if (item.Checked) {
            return (
                <div className="ConfirmReviewCheckedModalBodyComplete">
                    <p>{text}</p>
                </div>
            )
        }
        return (
            <div className="ConfirmReviewCheckedModalBodyIncomplete">
                <p>{text}</p>
            </div>
        )
    }

    toggleChecked = (index: number) => {
        this.index = index
        let temp = this.state.checklist
        //@ts-ignore
        let toggle = temp[index].Checked
        //@ts-ignore
        temp[index].Checked = !toggle
        this.setState({ checklist: temp, confirm: !this.state.confirm })
    }

    toggle = (key: string) => {
        let temp: any = this.state
        temp[key] = !temp[key]
        this.setState(temp)
    }

    save = (shouldSave: boolean) => {
        if (shouldSave) {
            this.updateChecklist(this.state.checklist[this.index])
        } else {
            this.toggleChecked(this.index)
        }
        this.setState({ confirm: !this.state.confirm })
    }

    render() {

        let checklist = this.state.checklist
        let progress = this.progress()
        let variant = this.calculateVariant(progress.percent)
        let loading = this.state.loading
        let checklistTitle = "Review"
        const readOnly = this.props.readOnly

        const toolTip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text || "No description availale"}
            </Tooltip>
        )

        let pillType = "Raised"
        
        return (
            <div className="ReviewChecklist">
                <div className="ReviewChecklistHeader">
                    <div className={`ReviewChecklistHeaderLeft${pillType}`}>
                        {progress.percent === 100 && <span className="material-icons">done</span>}
                        <p>{checklistTitle} checklist</p>
                    </div>
                    {!loading && !readOnly &&   <div className="ReviewChecklistHeaderRight">
                        <span id="review-checklist-gear-btn" className="material-icons" onClick={() => this.toggle("config")}>settings</span>
                        {/* <span id="vehicle-review-checklist-info-btn" className="material-icons">info</span> */}
                    </div>}
                    {loading && <div className="ReviewChecklistHeaderRight">
                        <Spinner id="review-checklist-load-spinner" animation="border" />
                    </div>}
                </div>
                <div className="ReviewChecklistBody">
                    {checklist.map((item: ReviewChecklistTypes, index: number) =>
                        <div className="ReviewChecklistBodyListItem" key={item.EmployeeReviewChecklistId}>
                            <div className="ReviewChecklistItem">
                                <input onChange={() => this.toggleChecked(index)} disabled={readOnly} checked={item.Checked} type="checkbox"></input>
                                {item.ChecklistText.length >= 20 && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.ChecklistText)}>
                                    <p>{item.ChecklistText}</p>
                                </OverlayTrigger>}
                                {item.ChecklistText.length < 20 && <p>{item.ChecklistText}</p>}
                            </div>
                            <div className="ReviewChecklistItemDescription">
                                {item.InfoText && item.InfoText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.InfoText)}>
                                    <span className="material-icons">info</span>
                                </OverlayTrigger>}
                                {item.DocumentLink && item.DocumentLink !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.DocumentLink)}>
                                    <a href={item.DocumentLink || ""} target="_blank" rel="noreferrer"><span className="material-icons">description</span></a>
                                </OverlayTrigger>}
                                {item.Email && item.Email !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.Email)}>
                                    <a href={`mailto:${item.Email || ""}`} target="_blank" rel="noreferrer"><span className="material-icons">mail</span></a>
                                </OverlayTrigger>}
                                {item.Phone && item.Phone !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.Phone)}>
                                    <a href={`tel:${reggie.formatPhone(item.Phone || "")}`}><span className="material-icons">call</span></a>
                                </OverlayTrigger>}
                            </div>
                        </div>)}
                </div>
                <div className="ReviewChecklistFooter">
                    <p>{progress.sum} Completed</p>
                    <ProgressBar id={`vehicle-review-checklist-progress-bar-${variant}`} now={progress.percent} />
                </div>
                {this.state.confirm && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ConfirmReviewCheckedModalHeader">
                            {this.modalHeaderText()}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ConfirmReviewCheckedModalBody">
                            {this.modalBodyText()}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="ConfirmReviewCheckedModalFooter">
                            <Button variant="secondary" onClick={() => this.save(false)}>Cancel</Button>
                            <Button variant="primary" onClick={() => this.save(true)}>Yes</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.config &&
                    <ReviewChecklistConfig
                        toggleConfig={this.toggle}
                        checklist={checklist}
                        updateReviewChecklist={this.updateChecklist}
                        contextUserId={this.props.reviewerId}
                        EmployeeReviewId={this.props.EmployeeReviewId}
                        loading={this.state.loading}
                        employeeName={this.props.employeeName}
                    />}
            </div>
        )
    }
}

export default ReviewChecklist